import type { ApplicationCompletion } from '@/stores/user-onboarding-completion';

/** True when all onboarding segments are done (same condition as onboarding “complete” step). */
export function isApplicationCompletionFullyComplete(
  data: ApplicationCompletion | undefined | null
): boolean {
  if (!data) {
    return false;
  }
  return (
    data.isCompleteProfile &&
    data.isCompleteWorksetup &&
    data.isCompleteCleaningSuppplies &&
    data.isCompleteAvailabilitySetup &&
    data.isStripeSetup
  );
}

/** Mirrors OnboardingCompletionBootstrapper / onboarding page step derivation. */
export function computeOnboardingCurrentStep(
  data: ApplicationCompletion,
  previousCurrentStep: number
): number {
  const profileOk = data.isCompleteProfile;
  const worksetupOk = data.isCompleteWorksetup;
  const cleaningOk = data.isCompleteCleaningSuppplies;
  const availabilityOk = data.isCompleteAvailabilitySetup;
  const stripeSetupOk = data.isStripeSetup;

  const shouldShowProfileSection = !profileOk || !worksetupOk || !cleaningOk;
  const shouldShowAvailabilitySection =
    !shouldShowProfileSection && !availabilityOk;
  const shouldShowSetupDeposit =
    !shouldShowProfileSection &&
    !shouldShowAvailabilitySection &&
    !stripeSetupOk;
  const shouldShowOnboardingComplete =
    profileOk && worksetupOk && cleaningOk && availabilityOk && stripeSetupOk;

  let currentStep = data.currentStep ?? previousCurrentStep;

  if (shouldShowProfileSection) {
    currentStep = 2;
  } else if (shouldShowAvailabilitySection) {
    currentStep = 3;
  } else if (shouldShowSetupDeposit) {
    currentStep = 4;
  } else if (shouldShowOnboardingComplete) {
    currentStep = 5;
  }

  return currentStep;
}
